export default {
  prod: {
    url: 'https://polls.ucomms.com.au',
    port: '',
    principalWorkspace: '654b09ab275d2c5af6a87b6405340a2e59bc7539967f1a2819a872435c6c0799',
    wfApi: 'https://workflows.yabbr.io/2022-02-14',
    ybApi: 'https://api.yabbr.io/2019-01-23',
    pollApi: 'https://polls.ucomms.com.au/2023-09-22',
    dmsApi: 'https://dms.yabbr.io/2022-05-31',
    scheduleApi: 'https://scheduler.yabbr.io/2022-02-14',
    toApi: 'https://timeout.yabbr.io/2022-07-22',
    custodianApi: 'https://custodian.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://go.yabbr.io',
    workflows: {},
    userFriendlyName: 'Production',
  },
  dev: {
    url: 'https://polls.dev.yabbr.io',
    port: '',
    principalWorkspace: 'dd8f595b3028eeffb848cfbedaaee03479900231c0fe863e5dcaadf2fe2c978f',
    wfApi: 'https://workflows.dev.yabbr.io/2022-02-14',
    ybApi: 'https://api.dev.yabbr.io/2019-01-23',
    pollApi: 'https://polls.dev.yabbr.io/2023-09-22',
    dmsApi: 'https://dms.dev.yabbr.io/2022-05-31',
    scheduleApi: 'https://scheduler.dev.yabbr.io/2022-02-14',
    toApi: 'https://timeout.dev.yabbr.io/2022-07-22',
    custodianApi: 'https://custodian.dev.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://go.dev.yabbr.io',
    workflows: {},
    userFriendlyName: 'Development',
  },
  local: {
    url: 'http://localhost:8087',
    port: '8087',
    principalWorkspace: 'dd8f595b3028eeffb848cfbedaaee03479900231c0fe863e5dcaadf2fe2c978f',
    wfApi: 'https://workflows.dev.yabbr.io/2022-02-14',
    ybApi: 'https://api.dev.yabbr.io/2019-01-23',
    pollApi: 'https://polls.dev.yabbr.io/2023-09-22',
    dmsApi: 'https://dms.dev.yabbr.io/2022-05-31',
    scheduleApi: 'https://scheduler.dev.yabbr.io/2022-02-14',
    toApi: 'https://timeout.dev.yabbr.io/2022-07-22',
    custodianApi: 'https://custodian.dev.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://go.dev.yabbr.io',
    workflows: {},
    userFriendlyName: 'Local',
  },
};
